export const truncateDecimal = (num: number) => Math.trunc(num * 100) / 100;

export const isValidDecimal = (value: any) => (Math.abs(parseFloat(value)) && parseFloat(value) >= 0 ? true : false);

export const isValidInteger = (value: any) => (Number.isInteger(Number(value)) && parseInt(value) >= 0 ? true : false);

export const isValidValue = (value: number) => value === 0;

export const isValidPositive = (value: number) => /^\d+$/.test(String(value));

export const isPositiveInteger = (value: string | number): boolean => Number.isInteger(Number(value)) && Number(value) > 0;

export const isValidMeanWeight = (value: number) => value <= 70;
